import { Footer } from '@ifca-root/react-component/src/components/Footer/Footer'
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import { smTitle } from '@ifca-root/react-component/src/global/TitleVariable'
import { useMediaQuery } from '@ifca-root/react-component/src/helpers/PDFFormatter/mediaSize'
import ShareIcon from '@material-ui/icons/Share'
import { Pagination } from '@material-ui/lab'
import { Group, drawDOM, exportPDF } from '@progress/kendo-drawing'
import ShareDialog from 'components/Dialog/ShareDialog'
import saveAs from 'file-saver'
import {
  useGetBankAccountQuery,
  useGetShareAttachmentMutation,
  useGetUsersByAccountAndSoftwareQuery,
} from 'generated/graphql'
import { useMobilePDFZoom } from 'helpers/Hooks/useMobilePDFZoom'
import * as htmlToImage from 'html-to-image'
import React, { useState } from 'react'
import { useHistory, useParams } from 'react-router'
import './PDFStyle.scss'
import { useCBQueries } from './Query/useCBQueries'
import { ErrorDialog } from 'components/Dialog/ErrorDialog'
import ELetterPreview from 'containers/ARModule/Hooks/ELetterTemplate/ELetterPreview'

export const PDFPreviewCBV2 = (props: any) => {
  const user = JSON.parse(localStorage.getItem('loggedInUser'))
  const { accountType, docType } = props
  const [errMessage, setErrMessage] = useState(null)
  const [errDialog, setErrDialog] = useState(false)
  const [isDataHandled, setIsDataHandled] = useState<boolean>(false)
  const [pageLength, setPageLength] = useState(1)

  let history = useHistory()
  const { styles } = useMobilePDFZoom()
  const {
    CompanyID,
    PaymentID,
    ReceiptID,
    BankTransferID,
    BankAccountID,
  }: any = useParams()

  const {
    loading: UserLoading,
    data: { getUsersByAccountAndSoftware } = {
      getUsersByAccountAndSoftware: [],
    },
  } = useGetUsersByAccountAndSoftwareQuery({
    fetchPolicy: 'network-only',
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
  })

  const {
    loading: BankLoading,
    data: { getBankAccount } = { getBankAccount: [] },
  } = useGetBankAccountQuery({
    fetchPolicy: 'network-only',
    variables: { BankAccountID },
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    onCompleted: ({ getBankAccount }) => {
      setBankState(getBankAccount[0]?.BankProfile?.Name)
    },
  })

  const [width] = useMediaQuery()

  let routeSegments, title, smallTitle, DocumentID, itemName

  smallTitle = smTitle.CASH_BOOK

  switch (docType) {
    case 'payment':
      DocumentID = PaymentID
      routeSegments = 'Payment'
      title = 'CASH PAYMENT VOUCHER'
      itemName = 'PaymentItem'
      break
    case 'receipt':
      DocumentID = ReceiptID
      routeSegments = 'Receipt'
      title = 'CASH RECEIPT/INVOICE'
      itemName = 'ReceiptItem'
      break
    case 'bank-transfer':
      DocumentID = BankTransferID
      routeSegments = 'Bank Transfer'
      title = 'BANK TRANSFER VOUCHER'
      itemName = 'ToBankAccountDetail'
      break
  }

  const {
    loading,
    listData,
    LetterTemplateLoading,
    templateBody,
    IsWatermark,
    WatermarkText,
  } = useCBQueries({
    docType,
    CompanyID,
    BankAccountID,
    TransactionID: DocumentID,
    setErrMessage,
    setErrDialog,
  })

  const previewDetail: any = {
    ...listData[0],
    itemList: listData[0]?.[itemName],
    [itemName]: [],
  }

  // ========== Page definition ==========
  const [page, setCurrentPage] = useState<number>(0)

  // ========== Threshold definition ==========
  let totalItems

  if (docType === 'bank-transfer') totalItems = 1
  else totalItems = previewDetail?.[itemName]?.length

  let threshold
  if (totalItems > 15) {
    threshold = 15
  } else {
    threshold = 0
  }

  // ========== Remap Data for item list ==========
  const [remapData, setRemapData] = useState(null)

  /// ========== kendo-drawing PDF Download ===========
  const dataURItoFile = (dataurl, filename) => {
    dataurl.replace('data:application/pdf;base64,', '')
    var arr = dataurl.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n)
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n)
    }
    return new File([u8arr], filename, { type: mime })
  }

  const onPrint = () => {
    let element = document.getElementById('pdf-data-print')
    console.log('element', element)

    drawDOM(element, {
      paperSize: [794, 1123], // custom size in Kendo units (pt/px)
      scale: 1,
      margin: {
        top: '0mm',
        bottom: '0mm',
        left: '0mm',
        right: '0mm',
      },
      forcePageBreak: '.page-break',
    })
      .then((group: Group) => exportPDF(group))
      .then(dataURI => {
        let fileObject = dataURItoFile(
          dataURI,
          `${title} (${previewDetail?.DocNo}).pdf`
        )
        saveAs(fileObject, `${title} (${previewDetail?.DocNo}).pdf`)
      })
  }

  const onShare = async (filename = 'document.pdf') => {
    const element = document.getElementById('pdf-data-print')

    const group = await drawDOM(element, {
      paperSize: [794, 1123], // custom size in Kendo units (pt/px)
      scale: 1,
      margin: {
        top: '0mm',
        bottom: '0mm',
        left: '0mm',
        right: '0mm',
      },
      forcePageBreak: '.page-break',
    })

    const dataURI = await exportPDF(group)

    // Convert Base64 → Blob
    const byteString = atob(dataURI.split(',')[1])
    const mimeString = 'application/pdf'
    const ab = new ArrayBuffer(byteString.length)
    const ia = new Uint8Array(ab)
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i)
    }

    const blob = new Blob([ab], { type: mimeString })

    // ✅ Return a File object with PDF type
    const file = new File([blob], filename, { type: mimeString })
    return file
  }

  const [openShareDialog, setOpenShareDialog] = useState(false)
  const [openSendEmail, setOpenSendEmail] = useState(false)

  const [
    getShareAttachments,
    {
      data: { getShareAttachment } = { getShareAttachment: {} as any },
      loading: ShareAttachmentLoading,
    },
  ] = useGetShareAttachmentMutation({
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    onCompleted: () => {
      setOpenShareDialog(true)
    },
  })

  const onSubmit = blob => {
    getShareAttachments({ variables: { file: blob, CompanyID } })
  }
  const [bankState, setBankState] = useState<string>()

  const pdfToPrint = () => {
    return (
      <>
        {/* ========================================= */}
        {/* DOCS THAT IS SAVED AS PDF WHICH IS HIDDEN */}
        {/* ========================================= */}
        <div style={{ position: 'fixed', left: `-2000px` }}>
          <div id={'pdf-data-print'}>
            <ELetterPreview
              previewDetail={previewDetail}
              accountType={accountType}
              docType={docType}
              getUsersByAccountAndSoftware={getUsersByAccountAndSoftware}
              remapData={remapData}
              page={page}
              pageLength={pageLength}
              currencyCode={user?.companyCurrencyCode}
              htmlTemplate={templateBody}
              IsWatermark={IsWatermark}
              WatermarkText={WatermarkText}
            />
          </div>
        </div>
      </>
    )
  }

  const footerOptions = [
    {
      name: 'Share',
      onClick: async () => {
        // let temp = await document.getElementById('pdf-data-print')
        // temp.querySelectorAll('img').forEach(img => {
        //   img.setAttribute('crossorigin', 'anonymous')
        // })

        // htmlToImage
        //   .toBlob(temp, { style: { background: '#fff' } })
        //   .then(value => {
        //     onSubmit(value)
        //   })
        //   .catch(error => console.error(error, 'Something went wrong'))
        onSubmit(await onShare())
      },
      color: 'primary',
      props: { type: 'submit' },
      startIcon: <ShareIcon style={{ fontSize: '18px' }} />,
    },
    {
      name: 'Download',
      color: 'primary',
      onClick: () => {
        onPrint()
      },
    },
  ]

  return (
    <>
      {loading && <Loading />}
      {BankLoading && <Loading />}
      {UserLoading && <Loading />}
      {LetterTemplateLoading && <Loading />}
      {ShareAttachmentLoading && <Loading />}
      <MainHeader
        mainBtn="close"
        onClick={() => {
          if (previewDetail?.ApprovalStatus === 'COMPLETED') {
            history.push({
              pathname: `/${accountType}/${CompanyID}/submenu/${BankAccountID}/${docType}/${DocumentID}/detail`,
              state: previewDetail,
            })
          } else {
            history.push({
              pathname: `/${accountType}/${CompanyID}/submenu/${BankAccountID}/${docType}/`,
              state: previewDetail,
            })
          }
        }}
        smTitle={smallTitle}
        title={user?.companyName}
        routeSegments={[
          { name: `${smTitle}` },
          { name: `${routeSegments}` },
          { name: `${routeSegments}`, current: true },
        ]}
        rightRouteSegments={[{ name: 'Print', current: true }]}
      />
      <ContentWrapper footer>
        {/* ============================== */}
        {/* DISPLAYED IN HTML TO BE VIEWED */}
        {/* ============================== */}
        <div style={{ height: window.screen.height }}>
          <div style={styles.supercontainer}>
            <div style={styles.container}>
              <ELetterPreview
                previewDetail={previewDetail}
                accountType={accountType}
                docType={docType}
                getUsersByAccountAndSoftware={getUsersByAccountAndSoftware}
                remapData={remapData}
                page={page}
                pageLength={pageLength}
                currencyCode={user?.companyCurrencyCode}
                htmlTemplate={templateBody}
                IsWatermark={IsWatermark}
                WatermarkText={WatermarkText}
              />
            </div>
          </div>
        </div>
        <div
          className={
            width < 769 ? 'pagination-dis-mobile' : 'pagination-dis-desktop'
          }
        >
          <Pagination
            count={remapData?.length}
            shape="rounded"
            page={page + 1}
            onChange={(e, page) => {
              setCurrentPage(page - 1)
            }}
          />
        </div>
      </ContentWrapper>
      <ShareDialog
        shareTitle={`Cash Book - ${user?.companyName}(${bankState})`}
        title="Share"
        URL={getShareAttachment?.fileURL}
        setSimple={setOpenShareDialog}
        simple={openShareDialog}
        emailShare={openSendEmail}
        setSimpleEmail={setOpenSendEmail}
      />
      <Footer options={footerOptions} />
      <ErrorDialog
        errorDia={errDialog}
        setErrorDia={setErrDialog}
        errorMsg={errMessage}
        errorHeaderMsg={'Error!'}
      />
      {/* Component for PDFToPrint */}
      <div style={{ width: 1980 }}>{pdfToPrint()}</div>
    </>
  )
}

export default PDFPreviewCBV2
